import { useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from '../../components/admin/AdminGrid';

const fmtDate = (p) => p.value ? new Date(p.value).toLocaleDateString() : '-';

export default function DisconnectedCompanies() {
  const columns = useMemo(() => [
    { field: 'realmId', headerName: 'Realm ID' },
    { field: 'companyName', headerName: 'Company', minWidth: 180 },
    { field: 'orgName', headerName: 'Organization', minWidth: 180 },
    { field: 'orgCreatorEmail', headerName: 'Creator Email', minWidth: 200 },
    { field: 'disconnectionType', headerName: 'Type' },
    { field: 'reason', headerName: 'Reason', minWidth: 200 },
    { field: 'disconnectedAt', headerName: 'Disconnected At', valueFormatter: fmtDate },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getDisconnectedCompanies({ page: 0, size: 10000 });
    return res.content || [];
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-100 mb-4">Disconnected Companies</h1>
      <AdminGrid columns={columns} fetchData={fetchData} />
    </div>
  );
}
